/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { OneAppPermission } from '@/enums/permission.enum';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonAction, ButtonType } from '@epg/ng-components';
import { faEllipsisVertical, faXmark, IconDefinition } from '@fortawesome/pro-regular-svg-icons';

export interface OneAppButtonConfig {
  id: string;
  text?: string;
  disabled: boolean;
  callBackIdentifier: string;
  icon?: IconDefinition;
  secondaryIcon?: IconDefinition;
  type?: ButtonType;
  requiredPermissions: OneAppPermission[];
}
export interface OneAppActionsMenuConfig {
  id: string;
  disabled: boolean;
  actionsMenu: OneAppActionsMenuItemConfig[];
}
export interface OneAppActionsMenuItemConfig {
  id: string;
  text?: string;
  disabled: boolean;
  callBackIdentifier: string;
  icon?: IconDefinition;
  color?: string;
}
@Component({
  selector: 'oneapp-header',
  templateUrl: './oneapp-header.component.html',
  styleUrl: './oneapp-header.component.scss',
  standalone: false
})
export class OneappHeaderComponent {
  faXmark = faXmark;
  faEllipsisVertical = faEllipsisVertical;
  @Input() title: string = '';
  @Input() showSpinner: boolean = false;
  @Input() deleteButtonConfig: OneAppButtonConfig | undefined;
  @Input() customButtonConfig: OneAppButtonConfig | undefined;
  @Input() customButtonConfig2: OneAppButtonConfig | undefined;
  @Input() dismissButtonConfig: OneAppButtonConfig | undefined;
  @Input() saveButtonConfig: OneAppButtonConfig | undefined;
  @Input() actionsMenuConfig: OneAppActionsMenuConfig | undefined;
  @Output() buttonClick = new EventEmitter<string>();

  buttonAction = ButtonAction;

  onClick(buttonText: string) {
    this.buttonClick.next(buttonText);
  }
}
